export default {
  'get-list': {
    method: 'post',
    url: '/vehicle/insurance/list'
  },
  add: {
    method: 'post',
    url: '/vehicle/insurance'
  },
  update: {
    method: 'put',
    url: '/vehicle/insurance/ID'
  },
  delete: {
    method: 'delete',
    url: '/vehicle/insurance'
  }
}
